import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {CreatePriceLevelConfigsDialogData, CreatePriceLevelDataParams} from "./types/create-price-level-configs.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {SelectData} from "../../../../../../core/types/records-table.types";
import {CreatePriceLevelConfigsService} from "./services/create-price-level-configs.service";
import {createPriceLevelConfigsFields} from "./configs/create-price-level-configs-fields";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {
  CustomMatSelectComponent
} from "../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {CreatePriceLevelConfigsField} from "./types/create-price-level-configs-field.types";
import {DecimalLimitDirective} from "../../../../../../shared/directives/decimal-limit.directive";

@Component({
  selector: 'app-create-price-level-configs-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    CustomMatSelectComponent,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    DecimalLimitDirective
  ],
  templateUrl: './create-price-level-configs-modal.component.html',
  styleUrl: './create-price-level-configs-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreatePriceLevelConfigsModalComponent extends BaseModalComponent {
  private createPriceLevelConfigsDialogData = inject<CreatePriceLevelConfigsDialogData>(MAT_DIALOG_DATA);
  private createPriceLevelConfigsService = inject(CreatePriceLevelConfigsService);

  public readonly createPriceLevelConfigsFields = createPriceLevelConfigsFields;
  public gapTypeSelectData = signal<Array<SelectData>>([]);
  public articleSelectData = signal<Array<SelectData>>([]);
  public createPriceLevelConfigsForm: FormGroup = new FormGroup({});

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await this.initModal();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(this.createPriceLevelConfigsDialogData.modalKey);
  }

  public getOptions(key: string): Array<SelectData> {
    return key === 'article' ? this.articleSelectData() : this.gapTypeSelectData();
  }

  public handleSelectChange(value: string, key: string): void {
    this.createPriceLevelConfigsForm.get(key)?.setValue(value);
  }

  public async handleCreate(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: CreatePriceLevelDataParams = {
      ...this.createPriceLevelConfigsForm.value
    };

    await this.createPriceLevelConfigsService.createPriceLevelConfigsData(params)
      .then(() => this.closeDialog('success'))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private async initModal(): Promise<void> {
    this.modalStatesService.openModal(this.createPriceLevelConfigsDialogData.modalKey);
    this.loadingService.setIsLoadingState(true);
    this.createPriceLevelConfigsForm = this.baseModalService.getFormGroup<CreatePriceLevelConfigsField>(createPriceLevelConfigsFields);
    await this.createPriceLevelConfigsService.fetchArticleSelectData()
      .then((data) => this.articleSelectData.set(data));
    await this.createPriceLevelConfigsService.fetchGapTypeSelectData()
      .then((data) => this.gapTypeSelectData.set(data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
